module.exports = __webpack_public_path__ + "img/68.71853478.jpg";